import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";
import {Col, Row} from "react-bootstrap";
import MotionDiv from "../motionDiv";

function CtaBlock() {

    return (
        <section id="cta" className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content backgroundBlue">
            <div className="auto-container">
                <Row>
                    <Col lg={6} md={6} sm={12}>
                        <div className="grids">
                                <div className="grid">
                                    <MotionDiv delay={0.3} duration={0.5} variant={'zoomIn'} classes="grid-content">
                                        <figure>
                                            <img src={"/images/homepage/icons/badge.svg"} alt={"Certification"} width="100%" height="100%"/>
                                        </figure>
                                        <strong>Certification Qualiopi</strong>
                                        <span>Organisme de formation reconnu pour la qualité de ses actions inclusives.</span>
                                    </MotionDiv>
                                </div>
                                <div className="grid">
                                    <MotionDiv delay={0.5} duration={0.5} variant={'zoomIn'} classes="grid-content">
                                        <figure>
                                            <img src={"/images/homepage/icons/diamant.svg"} alt={"Sur mesure"} width="100%" height="100%"/>
                                        </figure>
                                        <strong>Solutions sur mesure</strong>
                                        <span>Accompagnement personnalisé, concret et centré sur l’humain.</span>
                                    </MotionDiv>
                                </div>
                                <div className="grid">
                                    <MotionDiv delay={0.7} duration={0.5} variant={'zoomIn'} classes="grid-content">
                                        <figure>
                                            <img src={"/images/homepage/icons/team.svg"} alt={"Équipe"} width="100%" height="100%"/>
                                        </figure>
                                        <strong>Équipe engagée</strong>
                                        <span>Experts mobilisés pour soutenir employeurs et candidats à chaque étape.</span>
                                    </MotionDiv>
                                </div>
                            </div>
                    </Col>

                    <Col lg={6} md={6} sm={12}>
                        <MotionDiv delay={0.3} variant={'toLeft'}>
                            <div className="col-12">
                                <div className="sec-title">
                                    <h2>
                                        Ensemble pour une <span>inclusion durable</span>
                                    </h2>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="text mt-30">
                                    <p>
                                        Faisons équipe ensemble pour <span>faire progresser l’inclusion</span> dans votre entreprise
                                        ou votre organisation.
                                        <br/>
                                        <br/>
                                        Nous sommes à votre disposition pour échanger avec vous afin de <span>comprendre vos besoins
                                        et vos attentes</span> et étudier avec vous <span>les solutions personnalisées qui vous correspondent</span>,
                                        que nous aurons le plaisir de déployer pour vous.
                                        <br/>
                                        <br/>
                                        <span><strong>Partageons un moment en visio pour parler inclusion !</strong></span>
                                    </p>
                                    <div className={'d-flex justify-content-center justify-content-sm-start'}>
                                        <ContactModal textButton="Je demande un rendez-vous"
                                                      showText={false} small="small"
                                                      linkPageContact={false}
                                                      iframe={false}
                                                      couleur={false}
                                                      formModal={true}/>
                                    </div>
                                </div>
                            </div>
                        </MotionDiv>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default CtaBlock;
